import React from 'react';
import "../App.css";
import { SRLWrapper } from "simple-react-lightbox";


const ImageGrid = () => {
    return (



        <SRLWrapper >
            <div className="checkout-text">Checkout our work...</div>
            {
                // h- 300 w- 300 desktop view
            }
            <div className="grid-image">

                <a href="6.jpg">
                    <div className="image-grid-member">
                        <img src="6.jpg" alt="TV mount view - 1" />
                    </div>

                </a>



                <a href="9.jpg">
                    <div className="image-grid-member">

                        <img src="9.jpg" alt="TV mount view - 2" />
                    </div>
                </a>

                <a href="2.jpeg">
                    <div className="image-grid-member">
                        <img src="2.jpeg" alt="TV mount view - 3" />
                    </div>
                </a>

                <a href="5.jpg">
                    <div className="image-grid-member">
                        <img src="5.jpg" alt="TV mount view - 4" />
                    </div>
                </a>

            </div>


        </SRLWrapper>






    );
}

export default ImageGrid;